import { render, staticRenderFns } from "./SelectPlataforma.vue?vue&type=template&id=5c98fc66"
import script from "./SelectPlataforma.vue?vue&type=script&lang=js"
export * from "./SelectPlataforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports